import React, {Component, Fragment, useEffect, useState} from 'react'
import Counter from "./counter";
import ProgressBar from "@ramonak/react-progress-bar";
import DonationButton from "./donation-button";

export default function FixedBar(props){

    const isMobile=props.context.isMobile

    if(!isMobile){
        return null
    }

    return(
        <div className={"bar"} style={{
            width:"100%",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            position:"fixed",
            bottom:"-0rem",
            padding:"0.8rem 0",
            zIndex:200,
        }}>
           <DonationButton {...props} style={{width:"70vw",fontSize:"1rem"}}/>
        </div>
    )
}
